/* balboa-wishlist.js — Wishlist/Favoritos nativa (sin app, sin cuenta).
   Guarda los handles de producto en localStorage. Pensada para extenderse
   a sincronización con la cuenta del cliente (mayoreo) en el futuro. */
(function () {
  var KEY = 'balboa_wishlist_v1';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function setList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function toggle(handle) {
    var list = getList();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    setList(list);
    return list;
  }

  function updateButtons() {
    var list = getList();
    var btns = document.querySelectorAll('.balboa-wishlist-btn');
    for (var i = 0; i < btns.length; i++) {
      var active = list.indexOf(btns[i].getAttribute('data-handle')) !== -1;
      btns[i].classList.toggle('is-active', active);
      btns[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function updateCount() {
    var n = getList().length;
    var els = document.querySelectorAll('.balboa-wishlist-count');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].hidden = n === 0;
    }
  }

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Balboa: escapa antes de inyectar en innerHTML (cierra XSS almacenado via título/URL de producto)
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderPage() {
    var grid = document.getElementById('balboa-wishlist-grid');
    if (!grid) return;
    var empty = document.getElementById('balboa-wishlist-empty');
    var list = getList();
    grid.innerHTML = '';
    if (!list.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;

    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var imgSrc = img ? esc(img + (img.indexOf('?') === -1 ? '?width=500' : '&width=500')) : '';
          var imgTag = img ? '<img src="' + imgSrc + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
          var url = esc(p.url);
          var card = document.createElement('div');
          card.className = 'balboa-wl-card';
          card.innerHTML =
            '<a class="balboa-wl-card__media" href="' + url + '">' + imgTag + '</a>' +
            '<div class="balboa-wl-card__body">' +
              '<a class="balboa-wl-card__title" href="' + url + '">' + esc(p.title) + '</a>' +
              '<div class="balboa-wl-card__price">' + money(p.price) + '</div>' +
              '<a class="balboa-wl-card__cta" href="' + url + '">' + esc(grid.getAttribute('data-cta') || 'View product') + '</a>' +
              '<button type="button" class="balboa-wl-card__remove balboa-wishlist-btn is-active" data-handle="' + esc(handle) + '" aria-pressed="true">' +
                esc(grid.getAttribute('data-remove') || 'Remove') +
              '</button>' +
            '</div>';
          grid.appendChild(card);
        })
        .catch(function () {});
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.balboa-wishlist-btn') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    toggle(handle);
    updateButtons();
    updateCount();
    if (btn.classList.contains('balboa-wl-card__remove')) {
      var card = btn.closest('.balboa-wl-card');
      if (card) card.remove();
      if (!getList().length) {
        var empty = document.getElementById('balboa-wishlist-empty');
        if (empty) empty.hidden = false;
      }
    }
  });

  function init() { updateButtons(); updateCount(); renderPage(); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', function () { updateButtons(); updateCount(); renderPage(); });
})();
